import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { dispatch } from '../store';

const initialState = {
  list: {
    next: 1,
    previous: null,
    current_page: 1,
    count: 1,
    total_pages: 1,
    results: [],
  },
  isGettingCategoriesList: false,
};

export const subCategorySlice = createSlice({
  name: 'subCategory',
  initialState,
  reducers: {
    setSubCategoryList: (state, action) => {
      const data = action.payload;
      state.list = {
        ...data,
        results: [...state.list.results, ...data.results],
      };
    },
    setIsGettingSubCategoryList: (state, action) => {
      state.isGettingCategoriesList = action.payload;
    },
    clearSubCategoryList: (state) => {
      state.list = {
        next: 1,
        previous: null,
        current_page: 1,
        count: 1,
        total_pages: 1,
        results: [],
      };
    },
    removeSubCategory: (state, action) => {
      const data = action.payload;
      state.list.results = state.list.results.filter((category) => !data.includes(category.id));
    },
    addSubCategory: (state, action) => {
      const payload = action.payload;
      state.list.results = [...payload, ...state.list.results];
    },
    updateSubCategory: (state, action) => {
      const updatedCategory = action.payload;
      const index = state.list.results.findIndex((category) => category.id === updatedCategory.id);
      if (index !== -1) {
        state.list.results[index] = updatedCategory;
      }
    },
  },
});

export const {
  setSubCategoryList,
  clearSubCategoryList,
  setIsGettingSubCategoryList,
  removeSubCategory,
  addSubCategory,
  updateSubCategory,
} = subCategorySlice.actions;

export default subCategorySlice.reducer;

export const handleClearSubCategoryList = () => {
  dispatch(clearSubCategoryList());
};

export const handleGetSubCategoriesList = async (filters) => {
  dispatch(setIsGettingSubCategoryList(true));

  try {
    const link = `sub-category/list/?query=${filters.query}&page_size=${filters.pageSize}&page=${filters.page + 1}&order_by=${filters.order_by}`;

    const res = await axios.get(link);
    if (res.status === 200) {
      if (parseInt(filters.page + 1, 10) === 1) {
        dispatch(clearSubCategoryList());
      }
      const data = res.data;
      dispatch(setSubCategoryList(data));
      dispatch(setIsGettingSubCategoryList(false));
    }
    return Promise.resolve();
  } catch (err) {
    dispatch(setIsGettingSubCategoryList(false));
    return Promise.reject(err);
  }
};

export const handleAddSubCategory = async (category) => {
  try {
    const response = await axios.post('sub-category/', category);
    dispatch(addSubCategory([response.data]));
    return Promise.resolve();
  } catch (err) {
    return Promise.reject();
  }
};

export const handleRemoveSubCategory = async (data) => {
  try {
    await axios.post('sub-category/remove/', { data });
    dispatch(removeSubCategory(data));
    return Promise.resolve();
  } catch (err) {
    return Promise.reject();
  }
};

export const handleUpdateSubCategory = async (category) => {
  try {
    const response = await axios.put(`sub-category/`, category);
    dispatch(updateSubCategory(response.data));
    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};
